import React from 'react'
import MappingTabs from './MappingTabs'

const DobovoTab = () => <MappingTabs />

export default DobovoTab



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/DobovoTab.js